export enum TipoTransacao {
  C = 0,
  D = 1,
  JUROS = 2,
  DIVIDENDO = 3,
  TAXA = 4,
  COBRANCA_SERVICO = 5,
  DEPOSITO = 6,
  TRANSFERENCIA_ATM = 7,
  TRANSFERENCIA_POS = 8,
  TRANSFERENCIA = 9,
  CHEQUE = 10,
  PAGAMENTO = 11,
  RETIRADA_DINHEIRO = 12,
  DEPOSITO_DIRETO = 13,
  DEBITO_COMERCIANTE = 14,
  PAGAMENTO_REPETIDO = 15,
  OUTRO = 16,
}
